/**
 * 機能フラグ（ソース管理）。
 *
 * env / Secrets ではなくこのファイルで解放環境を管理する。
 * 切替＝このファイルの編集コミットなので、push すれば CI の変更検知で
 * front が必ず再ビルド・再デプロイされる（env だけ変えても反映されない罠がない）。
 * また API キーが同居する env ファイルを触らずに済む。
 *
 * 環境判定は既存の REACT_APP_MODE（app/front/.env 由来。開発は "dev"）を読むだけで、
 * env ファイル自体の編集は不要。未知の環境名は必ず無効（安全側）になるため、
 * staging → production のブランチマージでこのファイルが流れても本番は勝手に有効化されない。
 *
 * functions 側の対: functions/src/config/featureFlags.ts（必ずセットで更新すること）
 */

/**
 * 片道の区間追加（issue #3015 拡張）を解放する環境（REACT_APP_MODE の値）。
 * 本番解放時は本番環境の REACT_APP_MODE 実値（Secrets 内の設定値）を確認して追記する。
 * FE だけ解放すると片道予約が /reserve のバリデーションで 400 になるため、
 * functions 側 featureFlags と同一コミット（または BE 先行）で揃えること。
 */
const ONE_WAY_ADDITIONAL_FLIGHT_ENABLED_ENVS: string[] = ["dev", "prod"];

export const isOneWayAdditionalFlightEnabled = (): boolean =>
  ONE_WAY_ADDITIONAL_FLIGHT_ENABLED_ENVS.includes(process.env.REACT_APP_MODE ?? "");
